import {
  flow,
  get,
  map,
} from 'lodash/fp';

import dynamicsClient from '../client';
import type { JobTableDefinition } from '../models/JobTableDefinition';
import xmlToJson from '../_xmlToJson';
import convertApiToDomain from './_convertApiToDomain';

const apiEndpoint = '/JobListing/Feed/5c25501e-af6e-439e-a42b-92792719590d';

export default (): Promise<JobTableDefinition[]> => (
  dynamicsClient.get(apiEndpoint)
    .then(flow(
      get('data'),
      xmlToJson,
      get('rss.channel.item'),
      map(convertApiToDomain),
    ))
);
